import useFetchSelect from 'elements/Hooks/useFetchSelect'
import { defaultFormItemLayout, rules } from 'modules/FormItems'
import React, { Component, Fragment } from 'react'
import { Col, Form, Row } from 'antd'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../modules/Utils'
import ClientsListSelect from '../../../elements/Select/Client/ClientsSelect'

function ReceiptForm(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { calculation, receipt, receiptType, transaction, onChangeContract, ContractsSelectCmp, onChangeClient } = props

  const isFundsRequest = get(transaction, 'receipt.type') === 'Funds Request'
  const lender = isFundsRequest && (getFieldValue('client._id') || '').replace('members/', '')

  const { SelectData: LendersSelect } = useFetchSelect({ url: 'lenders?select=_id,fn' })

  const { SelectData: LendersContractSelect } = useFetchSelect({
    url: `lenders/contracts/${lender}?type=interCompany`,
    dontFetch: isEmpty(lender),
    dependencyArray: [lender],
  })

  const isOnBehalf = get(transaction, 'receipt.type') === 'on-behalf-of-3rd-party'

  return (
    <Form layout={'horizontal'}>
      <Row>
        {receiptType !== 'deposit' && (
          <Fragment>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Bank Fees'}>
                {moneyInline(numVal(transaction, 'bankFees'), strVal(transaction, 'currency'))}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Payer'}>
                {strVal(transaction, 'remittance.order')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Bank Account'}>
                {strVal(transaction, 'bank.title')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Notes'}>
                {strVal(transaction, 'notes')}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Date'}>
                {dateFormat(dateVal(transaction, 'date'))}
              </Form.Item>
            </Col>
          </Fragment>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Company'}>
            {strVal(transaction, isOnBehalf ? 'onBehalfCompany.fn' : 'company.fn')}
          </Form.Item>
        </Col>
      </Row>
      <h4>{isFundsRequest ? 'Lender' : 'Client'} Details</h4>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={isFundsRequest ? 'Lender' : 'Client'}>
            {getFieldDecorator('client._id', {
              initialValue: get(receipt, 'client._id'),
              rules: rules.select,
            })(
              isFundsRequest ? (
                <LendersSelect
                  placeholder={'Select a Lender'}
                  style={{ width: '100%' }}
                  keyAtr={'owner'}
                  valueAtr={'fn'}
                  disabled={receiptType === 'deposit'}
                  onChange={onChangeClient}
                />
              ) : (
                <ClientsListSelect
                  placeholder={'Select a Client'}
                  style={{ width: '100%' }}
                  keyAtr={'_id'}
                  disabled={receiptType === 'deposit'}
                  valueAtr={'fn'}
                  onChange={onChangeClient}
                />
              )
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Contract '}>
            {getFieldDecorator('contract._id', {
              initialValue: get(receipt, 'contract._id'),
              rules: [{ required: true, message: 'Please Select a Contract!' }],
            })(
              isFundsRequest ? (
                <LendersContractSelect
                  style={{ width: '100%' }}
                  keyAtr={'_id'}
                  disabled={receiptType === 'deposit'}
                  valueAtr={'title'}
                  placeholder={'Contracts Account'}
                  onChange={onChangeContract}
                />
              ) : (
                <ContractsSelectCmp
                  style={{ width: '100%' }}
                  keyAtr={'_id'}
                  disabled={receiptType === 'deposit'}
                  valueAtr={'title'}
                  placeholder={'Contracts Account'}
                  onChange={onChangeContract}
                />
              )
            )}
          </Form.Item>
        </Col>
        {/*{receiptType !== 'deposit' && (*/}
        {/*<Col span={12}>*/}
        {/*<Form.Item {...defaultFormItemLayout} label={'Deposit to Account'}>*/}
        {/*{getFieldDecorator('contract.amount', {*/}
        {/*initialValue: get(receipt, 'contract.amount'),*/}
        {/*})(*/}
        {/*<InputNumber*/}
        {/*style={{width: '100%'}}*/}
        {/*onChange={onChangeContractAllocated}*/}
        {/*/>,*/}
        {/*)}*/}
        {/*</Form.Item>*/}
        {/*</Col>*/}
        {/*)}*/}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Amount'}>
            {moneyInline(numVal(transaction, 'amount'), strVal(transaction, 'currency'))}
          </Form.Item>
        </Col>
        <Col span={12}>
          {' '}
          <Form.Item {...defaultFormItemLayout} label={'Invoices Allocation'}>
            {moneyInline(numVal(calculation, 'allocated'), strVal(transaction, 'currency'))}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Total Invoices Balance'}>
            {moneyInline(numVal(calculation, 'total'), strVal(transaction, 'currency'))}
          </Form.Item>
        </Col>
        <Col span={12}>
          {' '}
          <Form.Item
            style={{
              color: Math.round(numVal(calculation, 'remaining') * 100) / 100 === 0 ? '#44ad4f' : '#f5222d',
            }}
            {...defaultFormItemLayout}
            label={'Transaction Remaining'}>
            {moneyInline(numVal(calculation, 'remaining'), strVal(transaction, 'currency'))}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

ReceiptForm.propTypes = {}
ReceiptForm.defaultProps = { transaction: {}, receipt: {}, type: 'new' }

export default compose(Form.create(), withLoadingSection)(ReceiptForm)
